import { useQuery } from "@apollo/client/react";
import type { InvoiceOverviewResponse } from "../../../models/InvoiceModels";
import GET_INVOICE_OVERVIEW_DETAILS from "../../queries/invoices/getInvoiceOverviewDetails";

export const useInvoiceOverviewDetails = (
  clientIdentifier?: string,
  invoiceId?: string,
) => {
  const { data, error, loading, refetch } = useQuery<{
    invoice: InvoiceOverviewResponse;
  }>(GET_INVOICE_OVERVIEW_DETAILS, {
    variables: {
      clientIdentifier: clientIdentifier,
      invoiceId: invoiceId,
    },
    errorPolicy: "all",
    skip: !clientIdentifier || !invoiceId,
  });
  return { invoice: data?.invoice, error, loading, refetch };
};
